import * as tslib_1 from "tslib";
import { SvgIcon } from '@nextiva/next-ui';
import React from 'react';
import { isFiniteNumber } from '../../../utils/checks';
import gaugeIcon from './assets/icons/gauge.svg';
import "./GaugeViewChart.css";

var GaugeViewChartSvg = function GaugeViewChartSvg(_a) {
  var color = _a.color,
      degree = _a.degree,
      other = tslib_1.__rest(_a, ["color", "degree"]);

  return React.createElement("div", {
    className: "gauge-view-chart-svg"
  }, React.createElement(SvgIcon, tslib_1.__assign({
    className: color,
    src: gaugeIcon
  }, other)), isFiniteNumber(degree) && React.createElement("div", {
    className: "gauge-view-chart-svg__needle",
    style: {
      transform: "rotate(" + degree + "deg)"
    }
  }));
};

export default GaugeViewChartSvg;